
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetomumbaionewaycabservice() {



    const cardData =
    {
        keyword: 'Pune to Mumbai One Way Cab Service',
        heading: 'Meghana Cab : Pune to Mumbai One Way Cab Service',
        headingDescription: 'Meghana Cab offers Pune to Mumbai One Way Cab Service, providing a convenient and cost-effective travel option for individuals and groups. Whether you are heading to Mumbai for business, leisure, or a family visit, our fleet of clean and comfortable cabs ensures a smooth and stress-free journey. With options ranging from Hatchbacks and Sedans to SUVs and Tempo Travellers, we cater to every travel need. Enjoy door-to-door service, professional drivers, transparent pricing, and on-time pickups. Book your Pune to Mumbai One Way Cab with Meghana Cab for a reliable, safe, and affordable travel experience without the hassle of return charges.',


        top: 'Top Places to Visit in Mumbai with Meghana Cab',

      "topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most enduring symbol, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this colossal basalt arch marks the point from which the last British troops left India, making it both a historical and emotional landmark. Located in Apollo Bunder, it serves as a hub for ferry rides to Elephanta Island and provides stunning views at sunrise and sunset. The Indo-Saracenic style architecture and its vibrant surroundings filled with street vendors, photographers, and tourists make it a dynamic cultural hub."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A masterpiece of Victorian Gothic Revival architecture fused with Indian design, CST (formerly Victoria Terminus) is a UNESCO World Heritage Site and one of India’s busiest railway stations. Constructed in 1887, the terminus features turrets, pointed arches, domes, stained-glass windows, and intricate carvings of animals and deities. It stands as a testament to colonial-era craftsmanship while functioning as a modern-day transport lifeline for over 3 million daily commuters. Its majestic façade is especially breathtaking when illuminated at night."
  },
  {
    "title": "Marine Drive & Girgaon Chowpatty",
    "description": "Stretching 3.6 kilometers along the Arabian Sea, Marine Drive is Mumbai’s iconic palm-lined promenade shaped like a necklace, earning it the nickname 'Queen’s Necklace.' It’s a favorite spot for joggers, lovers, and tourists who gather to admire the sea view and city skyline, especially at sunset. At the northern end lies Girgaon Chowpatty, a lively beach known for its street food—bhel puri, pav bhaji, gola—and as a venue for the grand Ganesh Visarjan immersions. The entire stretch embodies Mumbai’s coastal spirit and urban pulse."
  },
  {
    "title": "Elephanta Caves",
    "description": "Located 11 km offshore on Elephanta Island, these 5th-to-8th-century rock-cut caves are a UNESCO World Heritage Site showcasing ancient Indian art dedicated primarily to Lord Shiva. The highlight is the massive Trimurti sculpture—depicting the three aspects of Shiva—carved into a single rock face. The island offers not just religious and artistic significance but also scenic views, lush trails, and a tranquil ferry ride from the Gateway of India, making it a full-day cultural and nature getaway from Mumbai's bustle."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "One of the richest and most visited temples in Mumbai, Siddhivinayak is dedicated to Lord Ganesha, the remover of obstacles. Originally built in 1801, it features a gold-plated inner sanctum and a unique idol carved from a single black stone, with the trunk curving to the right. The temple draws politicians, Bollywood celebrities, and millions of devotees annually, especially on Tuesdays when the lines stretch for hours. Despite the crowds, the spiritual atmosphere and meticulous organization make it a peaceful yet powerful experience."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Built in 1431 in honor of the Sufi saint Haji Ali, this Indo-Islamic marble dargah sits on a tiny islet 500 meters off the coast, connected by a narrow causeway that floods during high tide. It is visited by people of all religions and backgrounds, symbolizing Mumbai’s spiritual inclusiveness. With white domes, intricate mirror work, and prayers echoing against sea winds, it offers both a religious and atmospheric experience. The view of the Mumbai skyline from the dargah adds a contemplative beauty to the site."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya (Prince of Wales Museum)",
    "description": "Housed in a grand Indo-Saracenic building amidst lush gardens, this museum features over 50,000 artifacts from ancient to modern India. Its galleries cover art, archaeology, armory, numismatics, and decorative arts, including standout collections of miniature paintings, Buddhist sculptures, Mughal weaponry, and European antiques. The museum offers guided tours, audio guides, and children's workshops, making it both educational and engaging for visitors of all ages. Its architectural grandeur and curated exhibits make it one of India’s finest museums."
  },
  {
    "title": "Colaba Causeway",
    "description": "A vibrant shopping and cultural district near the Gateway of India, Colaba Causeway offers a sensory overload of colors, sounds, and flavors. Street stalls sell everything from junk jewelry and antiques to clothing and souvenirs, while iconic cafés like Leopold and Café Mondegar cater to tourists and locals alike. It’s the perfect place to experience Mumbai’s cosmopolitan vibe, blending colonial architecture with contemporary fashion, street food, and bustling life from early morning until late night."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular coastal stretches, offering a blend of natural beauty, local flavors, and a touch of celebrity culture. Frequented by locals for evening walks, kite flying, and beachside yoga, the beach is also known for its chaat stalls, pony rides, and occasional film shoots. It's common to spot Bollywood stars residing nearby. The beach also hosts cultural festivals and public events, making it more than just a leisure destination—it’s a slice of Mumbai’s identity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "This 87-square-kilometer green oasis within city limits offers a rare mix of wildlife sanctuary, recreational space, and ancient history. The park houses deer, leopards, monkeys, and over 250 species of birds, along with a toy train, boating lake, and nature trails. The Kanheri Caves within the park—dating from 1st century BCE to 10th century CE—are a group of over 100 Buddhist rock-cut monasteries and prayer halls. The combination of spirituality, wildlife, and open space makes it one of Mumbai’s most unique destinations."
  }
],

"services": [
    {
        "name": "Pune to Mumbai One Way Taxi",
        "description": "Travel conveniently with our one way taxi service from Pune to Mumbai. Perfect for single trips, our cabs offer comfort, punctuality, and professional drivers."
    },
    {
        "name": "One Way Travel Cab Pune to Mumbai",
        "description": "Book a one way travel cab from Pune to Mumbai for seamless intercity transportation. Ideal for business, family, or personal trips with no return hassle."
    },
    {
        "name": "AC Cab One Side Pune to Mumbai",
        "description": "Enjoy a relaxing journey in our air-conditioned one-side cab from Pune to Mumbai. Clean vehicles and reliable drivers ensure a stress-free ride."
    },
    {
        "name": "Budget One Way Cab Pune Mumbai",
        "description": "Choose our budget-friendly one way cab service from Pune to Mumbai. Great value for safe, comfortable, and dependable travel at affordable rates."
    },
    {
        "name": "Sedan for One Way Trip Pune to Mumbai",
        "description": "Hire a comfortable sedan for your one way trip from Pune to Mumbai. Ideal for solo travelers and couples seeking a smooth, private ride."
    },
    {
        "name": "SUV One Way Hire Pune to Mumbai",
        "description": "Need more space? Our SUV one way hire from Pune to Mumbai is perfect for groups or travelers with luggage, offering spacious and smooth travel."
    },
    {
        "name": "Online Booking One Way Cab Pune to Mumbai",
        "description": "Book your one way cab from Pune to Mumbai online in just a few steps. Enjoy instant confirmation and transparent pricing with no hidden charges."
    },
    {
        "name": "Private Cab Pune to Mumbai One Side",
        "description": "Hire a private cab for one side travel from Pune to Mumbai for a personal and secure ride. Ideal for VIPs, families, and solo passengers."
    },
    {
        "name": "Long Distance One Way Pune to Mumbai Cab",
        "description": "Get a reliable cab for long-distance one way travel from Pune to Mumbai. Our fleet ensures comfort and punctuality on every intercity trip."
    },
    {
        "name": "Chauffeur Driven One Way Taxi Pune to Mumbai",
        "description": "Enjoy executive service with our chauffeur-driven one way taxi from Pune to Mumbai. Experience premium comfort and professionalism throughout the journey."
    },
    {
        "name": "Business One Way Cab Pune to Mumbai",
        "description": "Book a business-class one way cab from Pune to Mumbai. Suited for corporate travelers, our service offers punctuality, professionalism, and peace of mind."
    },
    {
        "name": "Fast One Way Cab Booking Pune to Mumbai",
        "description": "Get fast and easy cab booking for one way trips from Pune to Mumbai. Save time with our quick booking system and prompt cab arrival."
    },
    {
        "name": "24/7 Pune to Mumbai One Way Cab Service",
        "description": "Our 24/7 one way cab service from Pune to Mumbai is always available. Book anytime, day or night, for a reliable and safe ride."
    },
    {
        "name": "Affordable Fare One Way Pune to Mumbai Cab",
        "description": "Travel cost-effectively with our affordable one way cab fares from Pune to Mumbai. Transparent pricing and quality service guaranteed."
    },
    {
        "name": "Family Travel One Way Cab Pune to Mumbai",
        "description": "Planning a family trip? Book our one way cab from Pune to Mumbai designed for families, with child-safe seating and ample luggage space."
    }
],
"tableData": [
    ["Pune to Mumbai One Way Taxi", "One Way Travel Cab Pune to Mumbai"],
    ["AC Cab One Side Pune to Mumbai", "Budget One Way Cab Pune Mumbai"],
    ["Sedan for One Way Trip Pune to Mumbai", "SUV One Way Hire Pune to Mumbai"],
    ["Online Booking One Way Cab Pune to Mumbai", "Private Cab Pune to Mumbai One Side"],
    ["Long Distance One Way Pune to Mumbai Cab", "Chauffeur Driven One Way Taxi Pune to Mumbai"],
    ["Business One Way Cab Pune to Mumbai", "Fast One Way Cab Booking Pune to Mumbai"],
    ["24/7 Pune to Mumbai One Way Cab Service", "Affordable Fare One Way Pune to Mumbai Cab"],
    ["Family Travel One Way Cab Pune to Mumbai", ""]
],







"whychoose": [
    {
        "WhyChooseheading": "Reliable One Way Cab Service from Pune to Mumbai",
        "WhyChoosedescription": "Our Pune to Mumbai one way cab service ensures a smooth, timely, and dependable ride. Whether you’re heading to a meeting, catching a flight, or visiting family, we make sure you travel stress-free with punctual pickups and efficient routes."
    },
    {
        "WhyChooseheading": "Comfortable and Clean Vehicles for Every Need",
        "WhyChoosedescription": "Travel in comfort with our fleet of well-maintained vehicles, including sedans, SUVs, and premium cars. All cabs are thoroughly cleaned before each trip and come equipped with air-conditioning, cushioned seating, and plenty of luggage space for a relaxed travel experience."
    },
    {
        "WhyChooseheading": "Experienced Chauffeurs for a Safe Journey",
        "WhyChoosedescription": "Our professional drivers are background-verified, well-trained, and familiar with the Pune-Mumbai highway and city routes. They drive safely, follow traffic rules, and ensure your ride is pleasant, secure, and hassle-free throughout the journey."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "With our one way cab service, you only pay for what you use. There are no hidden charges—our all-inclusive pricing covers fuel, tolls, driver fees, and taxes. Get quality service at a reasonable rate, making your intercity trip cost-effective."
    },
    {
        "WhyChooseheading": "Flexible Booking and Multiple Vehicle Options",
        "WhyChoosedescription": "Whether you’re traveling solo or with a group, we offer multiple vehicle choices to suit your needs. Choose from economy to premium models. Book instantly online or in advance with full flexibility to modify your travel plans if needed."
    },
    {
        "WhyChooseheading": "Doorstep Pickup and Drop for Maximum Convenience",
        "WhyChoosedescription": "Enjoy a seamless travel experience with our door-to-door service. We pick you up from your chosen location in Pune and drop you off directly at your destination in Mumbai, saving you the trouble of changing vehicles or commuting to pick-up points."
    },
    {
        "WhyChooseheading": "Ideal for Airport Transfers, Business Trips, and Family Travel",
        "WhyChoosedescription": "Our Pune to Mumbai one way cab is the perfect solution for various travel needs—whether it’s an airport transfer, an urgent business meeting, a weekend getaway, or a family visit. We ensure comfort, punctuality, and peace of mind every mile of the way."
    },
    {
        "WhyChooseheading": "24/7 Customer Support and Real-Time Assistance",
        "WhyChoosedescription": "From booking to arrival, our customer support team is available round the clock to assist with any questions, route changes, or special requests. We monitor your trip in real-time to offer instant help and make sure your ride goes smoothly without interruptions."
    }
]































    }

const faqData = [
    {
        question: "How do I book a one way cab from Pune to Mumbai?",
        answer: "Booking is easy—just call Meghana Cab at +91 9075462128 or use our website for quick and secure booking."
    },
    {
        question: "Is the one way cab service available at all times?",
        answer: "Yes, Meghana Cab offers 24/7 one way cab services from Pune to Mumbai to suit your travel plans."
    },
    {
        question: "What are the cab options available for Pune to Mumbai one way travel?",
        answer: "We provide a variety of options including hatchbacks, sedans, SUVs, and tempo travellers depending on your travel requirements."
    },
    {
        question: "Are there any hidden charges for the one way trip?",
        answer: "No hidden charges. Our one way cab fare includes fuel, tolls, and driver fees. Extra charges may apply only for detours or extended waiting time."
    },
    {
        question: "Can I schedule my pickup for early morning or late night?",
        answer: "Yes, you can schedule your ride for any time—day or night. Our drivers are available 24/7 for your convenience."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Rohit Mehta',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Meghana Cab’s one way service from Pune to Mumbai was timely and very affordable. Great value for money!”',
    },
    {
        name: 'Ms. Sneha Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“I frequently travel between Pune and Mumbai. Meghana Cab always delivers a smooth and reliable one way cab experience.”',
    },
];















































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai One Way Cab Service",
  "image": "https://www.meghanacabs.com/assets/images/pune-to-mumbai-one-way-cab.jpg",
  "description": "Enjoy a comfortable and budget-friendly one way cab service from Pune to Mumbai with Meghana Cabs. Choose from AC Sedans, SUVs, and professional chauffeur-driven cabs. Available 24/7 with easy online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5213"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1799",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-mumbai-one-way-cab-service"
  }
};






    return (
        <div>


<Helmet>
  <title>Pune to Mumbai One Way Cab Service | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book a reliable one way cab from Pune to Mumbai with Meghana Cabs. Choose AC Sedans or SUVs for a comfortable journey. Affordable fares, professional drivers, and 24/7 service with online booking." 
  />
  <meta 
    name="keywords" 
    content="Pune to Mumbai One Way Taxi, One Way Travel Cab Pune to Mumbai, AC Cab One Side Pune to Mumbai, Budget One Way Cab Pune Mumbai, Sedan for One Way Trip Pune to Mumbai, SUV One Way Hire Pune to Mumbai, Online Booking One Way Cab Pune to Mumbai, Private Cab Pune to Mumbai One Side, Long Distance One Way Pune to Mumbai Cab, Chauffeur Driven One Way Taxi Pune to Mumbai, Business One Way Cab Pune to Mumbai, Fast One Way Cab Booking Pune to Mumbai, 24/7 Pune to Mumbai One Way Cab Service, Affordable Fare One Way Pune to Mumbai Cab, Family Travel One Way Cab Pune to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/79.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomumbaionewaycabservice;